<script setup>
  import {ref} from "vue";

  import ComponentBmpImportDialog from "@components/Dialogs/BmpImportDialog/BmpImportDialog.vue";
  import {MedButton, MedIcon} from "@pharma4u/medicheck-components";

  import DashboardWidget from "./Widget.vue";

  defineOptions({
    name: "DashboardBmpImportExclusiveWidget",
  });

  const refBmpImportDialog = ref(null);

  function openBmpImportDialog() {
    refBmpImportDialog.value.open();
  }
</script>

<template>
  <div>
    <DashboardWidget class="h-full" :test-id="getTestId('bmp-import-exclusive')">
      <template #title>
        <MedButton
          flat
          class="text-2xl"
          align="left"
          full-width
          :data-test="getTestId('open-bmp-dialog-headline-button')"
          @click.prevent="openBmpImportDialog()"
        >
          <span class="flex rounded-full bg-mcgreen p-1.5 font-normal text-white">
            <MedIcon icon="barcode_reader" size="lg" />
          </span>

          BMP importieren
        </MedButton>
      </template>

      <template #default>
        <p class="text-lg">Starten Sie mit einem Medikationsplan</p>
      </template>

      <template #actions>
        <MedButton :data-test="getTestId('open-bmp-dialog-button')" variant="secondary" @click="openBmpImportDialog()">
          BMP importieren
        </MedButton>
      </template>
    </DashboardWidget>

    <ComponentBmpImportDialog ref="refBmpImportDialog" />
  </div>
</template>
